import type React from 'react';
import { useEffect, useRef } from 'react';

export function Instrument({
  children,
  onInitialRender,
}: {
  children: React.ReactNode;
  onInitialRender: () => unknown;
}) {
  const once = useRef(false);
  const onInitialRenderRef = useRef(onInitialRender);
  onInitialRenderRef.current = onInitialRender;

  useEffect(() => {
    if (!once.current) {
      once.current = true;
      onInitialRenderRef.current();
    }
  }, []);

  return <>{children}</>;
}
